import React from 'react';
import { ExternalLink } from 'lucide-react';

export const CommunityPage: React.FC = () => {
  return (
    <div className="py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-6xl font-bold text-white mb-8">
          Join Our Global Discord Community
        </h1>
        
        <p className="text-xl text-gray-300 mb-12">
          Get help with your code, make friends, and share job-search tips
        </p>

        <div className="flex flex-col items-center gap-8 mb-12">
          <button 
            onClick={() => window.open('https://discord.com/oauth2/authorize?client_id=YOUR_CLIENT_ID&scope=identify%20guilds.join', '_blank')}
            className="bg-[#5865F2] hover:bg-[#4752C4] text-white font-semibold px-8 py-4 rounded-lg text-xl transition-colors flex items-center gap-3"
          >
            RE-SYNC DISCORD ACCOUNT
          </button>

          <a 
            href="https://discord.gg/opsquest" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 flex items-center gap-2"
          >
            Join our Boot.dev server <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="flex -space-x-4">
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-500"></div>
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-green-500 to-blue-500"></div>
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-500 to-pink-500"></div>
          </div>
          <span className="text-gray-300">
            Join 25,353 community members
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {[
            {
              title: "Get Help",
              description: "Stuck on a challenge? Get help from experienced DevOps engineers"
            },
            {
              title: "Make Friends",
              description: "Connect with other learners and build your professional network"
            },
            {
              title: "Find Jobs",
              description: "Access job opportunities and get referrals from community members"
            }
          ].map((feature, index) => (
            <div key={index} className="bg-gray-800/30 backdrop-blur border border-gray-700/50 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-white mb-3">{feature.title}</h3>
              <p className="text-gray-300">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gray-800/30 backdrop-blur border border-gray-700/50 rounded-lg p-8">
          <h2 className="text-2xl font-bold text-white mb-4">Community Guidelines</h2>
          <ul className="text-left text-gray-300 space-y-3">
            <li>• Be respectful and supportive of other members</li>
            <li>• Share knowledge and help others learn</li>
            <li>• No spam or self-promotion without permission</li>
            <li>• Keep discussions relevant to DevOps and technology</li>
            <li>• Follow Discord's terms of service</li>
          </ul>
        </div>
      </div>
    </div>
  );
}; 